import { SharedModule } from '../../../shared/shared.module';
import { CitizensForImpactListComponent } from './citizens-for-impact-list.component';
import { CitizensForImpactValidateComponent } from '../citizens-for-impact-validate/citizens-for-impact-validate.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';
import { BsDatepickerModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    DataTableModule,
    BsDatepickerModule.forRoot()
  ],
  declarations: [CitizensForImpactListComponent, CitizensForImpactValidateComponent],
  exports: [CitizensForImpactListComponent],
  entryComponents: [CitizensForImpactValidateComponent]
})
export class CitizensForImpactListModule { }
